import { AjusteCategoria, AjusteVariacao, Catalogo, CatalogoUnico, DescontoProgressivo, FiltroCatalogos, FiltroOrdemCatalogos, OpcoesDirecionamento } from "../types/Catalogo";
import { VariacaoPromocao } from "../types/Produto";
import { api } from "./useApi";

export const CatalogosApi = () => ({
  getVariacoesProduto: async (
    id_produto: number,
    id_tabela?: string | number
  ): Promise<{ id_produto: number; referencia: string; nome: string; variacoes: VariacaoPromocao[] }> => {
    const response = await api.post("/catalogo/variacoes_produto", {
      id_produto,
      id_tabela,
    });

    return response.data;
  },

  // Categorias, tags e variações que existem dentro do catálogo, a partir dos
  // produtos que estão selecionados na tela — não do que já foi salvo.
  getOpcoesDirecionamento: async (
    produtos: number[],
    todos_produtos: boolean
  ): Promise<OpcoesDirecionamento> => {
    const response = await api.post("/catalogo/opcoes_direcionamento", {
      produtos,
      todos_produtos,
    });

    return response.data as OpcoesDirecionamento;
  },

  getCatalogos: async (
    search: string,
    filter: FiltroCatalogos,
    order: FiltroOrdemCatalogos,
    limit: number,
    offset: number
  ) => {
    let response = await api.post("/catalogo/listagem", {
      search: search,
      filter: filter,
      order: order,
      limit: limit,
      offset: offset,
    });

    return response.data as { catalogos: Catalogo[]; criadores: any[] };
  },

  getCatalogo: async (id_catalogo: string): Promise<{ catalogo: CatalogoUnico; descontos_progressivos: DescontoProgressivo[]; ajustes_categoria: AjusteCategoria[]; ajustes_variacao: AjusteVariacao[] }> => {
    const responseData = (
      await api.post("/catalogo/unico", { id_catalogo: id_catalogo })
    ).data as { catalogo: CatalogoUnico; descontos_progressivos: DescontoProgressivo[]; ajustes_categoria: AjusteCategoria[]; ajustes_variacao: AjusteVariacao[] };

    let response = responseData.catalogo;
    const descontos_progressivos = responseData.descontos_progressivos || [];
    const ajustes_categoria = responseData.ajustes_categoria || [];
    const ajustes_variacao = responseData.ajustes_variacao || [];

    if (!Array.isArray(response.banners)) response.banners = [];
    if (response.configuracoes === null) response.configuracoes = { adicionarTodosProdutos: true, mostrarPrecoOriginal: false }
    return { catalogo: response, descontos_progressivos, ajustes_categoria, ajustes_variacao };
  },

  salvarCatalogo: async (catalogo: CatalogoUnico, descontos_progressivos?: DescontoProgressivo[], ajustes_categoria?: AjusteCategoria[], ajustes_variacao?: AjusteVariacao[]) => {
    const {
      outros_usuarios,
      identificacao,
      principal,
      duplicado,
      ...newCatalogo
    } = catalogo;

    const ids_usuarios = outros_usuarios.map((usuario) => usuario.id);

    let response = await api.post("catalogo/criar", {
      catalogo: newCatalogo,
      ids_usuarios: ids_usuarios,
      catalogo_principal: principal === "true" ? true : false,
      identificacao: identificacao,
      descontos_progressivos: descontos_progressivos || [],
      ajustes_categoria: ajustes_categoria || [],
      ajustes_variacao: ajustes_variacao || [],
    });
    return response.data;
  },

  removerCatalogo: async (id_catalogo: string) => {
    let response = await api.post("/catalogo/remover", {
      id_catalogo: id_catalogo,
    });
    return response.data;
  },

  getOutrosUsuarios: async (id_catalogo: string) => {
    let response = (await api.post("/usuario/usuarios_replicar_catalogo")).data;

    return response;
  },

  getCatalogosFiltroPedidos: async () => {
    let response = await api.post("/catalogo/todos_filtro_pedidos");
    return response.data;
  },

  getCatalogosCompartilhar: async () => {
    let response = await api.post("/catalogo/todos_compartilhar");
    return response.data;
  },

  getCategorias: async (identificacao_catalogo: number) => {
    let response = await api.post("/catalogo/listar_categorias", {
        identificacao_catalogo: identificacao_catalogo,
    });
    return response.data;
  },

  setCatalogoPrincipal: async (id_catalogo: string) => {
    let response = await api.post("/catalogo/atualizarCatalogoPrincipal", {
      id_catalogo: id_catalogo,
    });
    return response.data;
  },
  verificarLimiteCatalogos: async () => {
    let response = await api.post("/catalogo/verificar_limite");
    return response.data;
  }
});
